// extracted by mini-css-extract-plugin
module.exports = {"root":"TopInjector_root__-L3ZX"};